module.exports = __webpack_public_path__ + "static/media/clock.52b40157.svg";